module.exports = __webpack_public_path__ + "img/87.406bfa03.jpg";